import { AppFormItem, AppFormItemProps, AppInput } from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { createFieldValidationRules } from 'utils/formValidationHelpers';

export const LastNameInputElement = (props: AppFormItemProps) => (
    <AppFormItem
        label="Nazwisko"
        name={formFields.lastName}
        rules={createFieldValidationRules('lastName', {
            required: true,
            maxLength: 300,
        })}
        accessibilityLabel="Pole nazwisko"
        {...props}
    >
        <AppInput
            autoComplete="family-name"
            accessibilityLabel="Pole nazwisko"
            placeholder="Podaj nazwisko"
        />
    </AppFormItem>
);
